<template>
  <div v-if="visible" :class="['custom-alert', type]" @click="close">
    <i :class="iconClass" class="alert-icon"></i>
    <span>{{ message }}</span>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, computed } from 'vue';

const props = defineProps({
  message: String,
  type: {
    type: String,
    default: 'info' // can be 'success', 'error', 'warning', 'info'
  },
  duration: {
    type: Number,
    default: 3000
  }
});

const visible = ref(true);

const close = () => {
  visible.value = false;
};

const iconClass = computed(() => {
  switch (props.type) {
    case 'success':
      return 'fas fa-check-circle';
    case 'error':
      return 'fas fa-exclamation-circle';
    case 'warning':
      return 'fas fa-exclamation-triangle';
    case 'info':
    default:
      return 'fas fa-info-circle';
  }
});

onMounted(() => {
  setTimeout(() => {
    close();
  }, props.duration);
});
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

.custom-alert {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  max-width: 80vw;
  padding: 12px 20px;
  border-radius: 40px;
  color: white;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideDown 0.2s ease-out;
}

.custom-alert .alert-icon {
  font-size: 18px;
}

/* 蓝色主题 */
.custom-alert.info {
  background: linear-gradient(135deg, #1677ff, #4096ff);
}
.custom-alert.success {
  background: linear-gradient(135deg, #52c41a, #73d13d);
}
.custom-alert.error {
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
}
.custom-alert.warning {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
</style>


<!-- <style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

.custom-alert {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  transition: opacity 0.3s;
}

.custom-alert .alert-icon {
  margin-right: 10px;
  font-size: 18px;
}

.custom-alert.info {
  background-color: #2196f3;
}

.custom-alert.success {
  background-color: #4caf50;
}

.custom-alert.error {
  background-color: #d35656;
}

.custom-alert.warning {
  background-color: #e4ac57;
}
</style> -->
